import moment from "moment";
import React, { useState } from "react";
import { Dropdown, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { makeRESTApiRequests } from "../helpers/api";
import {
  ADMIN_NAVS,
  ADMIN_ROLE,
  ENDPOINTS,
  scheduleTimeDomains,
  tabs,
} from "../helpers/constants";
import useAuth from "../hooks/useAuth";

const Header = () => {
  const location = useLocation();
  const [disable, setDisable] = useState(false);

  const navigate = useNavigate();

  const { signOut, user } = useAuth();

  const logout = async () => {
    await signOut();
    navigate("/login");
  };

  const downloadCSV = async (csvType) => {
    setDisable(true);
    toast.info("Please wait downloading file...");

    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.DOWNLOAD_CSV_SERVICE,
      requestBody: { csvType },
    });

    if (response) {
      let csv = response;

      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `${csvType} - ${moment().format(
        "MMM DD, yyyy"
      )}.csv`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } else {
      toast(error, {
        type: "error",
      });
    }

    setDisable(false);
  };

  const NavItem = ({ name, path, abs = false, dropdown = false }) => {
    const linkPath = encodeURI(abs ? `/${path}` : `/jobs/${path}`);
    const active = location.pathname + location.search === linkPath;
    return dropdown ? (
      <NavDropdown.Item
        style={{ fontSize: 13 }}
        href={linkPath}
        active={active}
      >
        {name}
      </NavDropdown.Item>
    ) : (
      <Nav.Link
        className="text-lg-center"
        style={active ? styles.activeLink : styles.inActiveLink}
        href={linkPath}
        active={active}
      >
        {name}
      </Nav.Link>
    );
  };

  return (
    <>
      {" "}
      <Navbar bg="light" expand="lg" className="px-2">
        <Navbar.Brand href="/">
          <img src={process.env.PUBLIC_URL + "/atm-logo.png"} width="50px" alt="ATM" />
        </Navbar.Brand>{" "}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <NavDropdown
            disabled={disable}
            color="black"
            style={{ fontSize: 13, color: "black" }}
            title="CSV"
          >
            <NavDropdown.Item
              style={{ fontSize: 14 }}
              onClick={() => downloadCSV("Field Work")}
            >
              Field Work
            </NavDropdown.Item>
            <NavDropdown.Item
              style={{ fontSize: 14 }}
              onClick={() => downloadCSV("All (Not Cancelled)")}
            >
              All (Not Cancelled)
            </NavDropdown.Item>
          </NavDropdown>
          <Nav className="flex-grow-1">
            <NavDropdown
              style={
                location.pathname.includes("schedule")
                  ? styles.activeLink
                  : styles.inActiveLink
              }
              title="Schedule"
              active={location.pathname.includes("schedule")}
            >
              {scheduleTimeDomains.map((d) => (
                <NavItem
                  key={d}
                  name={d.replace("Time", "Schedule")}
                  path={`schedule?timeDomain=${d}`}
                  abs
                  dropdown
                />
              ))}
              <NavItem
                name="Set Availability"
                path="schedule/set-availability"
                abs
                dropdown
              />
            </NavDropdown>
            {tabs.map((tab, index) => (
              <NavItem
                key={tab.path}
                name={tab.name}
                path={tab.path}
                abs={tab?.abs}
              />
            ))}

            {/* Admin Section */}
            {user?.role === ADMIN_ROLE && (
              <NavDropdown
                active={location.pathname.includes("/admin/")}
                disabled={disable}
                color="black"
                style={{ fontSize: 13, color: "black" }}
                title="Admin"
              >
                {ADMIN_NAVS.map((nav, index) => {
                  return (
                    <NavDropdown.Item
                      key={nav?.route || index}
                      href={`/admin/${nav?.route}`}
                      style={{ fontSize: 14 }}
                      active={location.pathname === `/admin/${nav?.route}`}
                    >
                      {nav?.label}
                    </NavDropdown.Item>
                  );
                })}
              </NavDropdown>
            )}
          </Nav>

          <div className="d-flex">
            {" "}
            <Dropdown
              className={`d-none d-md-inline-block ms-1`}
              style={{ zIndex: 10 }}
              drop="left"
            >
              <Dropdown.Toggle
                size="sm"
                variant="outline-dark "
                className="d-flex align-items-center mx-0"
              >
                <PersonCircle size={14} className="mr-1 align-text-top" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className="smallFont"
                  onClick={() => navigate("/profile")}
                >
                  View Profile
                </Dropdown.Item>
                <Dropdown.Item className="smallFont" onClick={logout}>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown
              className={`d-inline-block d-md-none ms-1`}
              style={{ zIndex: 10 }}
              drop="right"
            >
              <Dropdown.Toggle
                size="sm"
                variant="outline-dark "
                className="d-flex align-items-center mx-0"
              >
                <PersonCircle size={14} className="mr-1 align-text-top" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className="smallFont"
                  onClick={() => navigate("/profile")}
                >
                  View Profile
                </Dropdown.Item>
                <Dropdown.Item className="smallFont" onClick={logout}>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Navbar.Collapse>{" "}
      </Navbar>
    </>
  );
};

const styles = {
  activeLink: {
    fontSize: 13,
    fontWeight: "bold",
  },
  inActiveLink: { fontSize: 13 },
};

export default Header;
